import { useMemo, useState } from "react";
import "./IntroBanners.css";
import { verificaAdmin } from "../../../../components/utils/verificaAdmin";
import AdminIntroBanners from "./AdminIntroBanners/AdminIntroBanners";

function IntroBanners({
  banners,
  loading,
  localizacao,
  ordem,
  atualizarBanners
}) {
  const [abrirAdmin, setAbrirAdmin] =
    useState(false);

  const isAdmin = verificaAdmin();

  const bannerIntro = useMemo(() => {
    if (!Array.isArray(banners)) return null;

    return banners.find(
      b =>
        b.localizacao === localizacao &&
        b.ordem === ordem
    );
  }, [banners, localizacao, ordem]);

  if (loading || !bannerIntro) return null;

  return (
    <>
      {isAdmin && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end"

          }}
        >
          <button
            className="btn-editar-categorias"
            onClick={() =>
              setAbrirAdmin(true)
            }
          >
            Editar
          </button>
        </div>
      )}

      {bannerIntro.imagem ? (
        <section className="intro-part6-banner">
          <img
            src={
              bannerIntro.imagem.startsWith("http")
                ? bannerIntro.imagem
                : process.env.PUBLIC_URL +
                bannerIntro.imagem
            }
            alt={`Banner ${ordem}`}
          />
        </section>
      ) : (
        isAdmin && (
          <section className="intro-part6-banner intro-part6-banner-admin">
            <p>{localizacao} {ordem}</p>
          </section>
        )
      )}

      {abrirAdmin && (
        <div
          className="admin-modal-overlay"
          onClick={() =>
            setAbrirAdmin(false)
          }
        >
          <div
            className="admin-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <AdminIntroBanners
              banner={bannerIntro}
              onClose={() =>
                setAbrirAdmin(false)
              }
              onSalvar={() => {
                atualizarBanners?.();
                setAbrirAdmin(false);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default IntroBanners;